/* @ngInject */
function HomeController ($scope, $translate, $timeout, $rootScope, $q, $state, GuestService, ApprovalsService, TasksService, ModalService, ToastService, SegmentService, GuestHeaderFiltersService) {
  const getRequestFormDialogController = () => $q.when(import('../../../workflow/dialogs/request-form/request-form-dialog.controller'))

  $scope.requestsSortOptions = []
  $scope.approvalsSortOptions = []
  $scope.searchResultsSortOptions = []

  $scope.flags = {
    loading: true,
    isSearchingOrFiltering: false,
    showOnlyAssetPacksTab: false
  }

  $scope.tabsCounts = {
    assetPacks: 0,
    approvals: 0,
    requests: 0
  }
  $scope.searchFilter = {
    items: [],
    count: 0
  }

  $scope.headerToolbar = {}

  let search
  let filters
  let hasBriefings = false

  const api = {
    getRequestFormDialogController,
    _checkShowOnlyAssetPacksTab,
    _initHeaderToolbar,
    _openRequestForm,
    _resetSearchFilterObject,
    _getTabsCounts,
    _resetTabObject,
    _getApprovalsOverdueCount,
    _getApprovals,
    _getRequests,
    _getAssetPacks,
    _clearSearchAndFilters,
    _search,
    _searchAssetPacks,
    _searchTasks,
    _sendSearchEvent,
    _reloadApprovalsTab,
    _getSort
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._checkShowOnlyAssetPacksTab().then(() => {
      let selectedTab
      if (!$scope.flags.showOnlyAssetPacksTab) {
        selectedTab = $state.params.selectedTab || 'approvals'
        api._resetTabObject('approvals')
        api._resetTabObject('requests')
      } else {
        selectedTab = 'assetPacks'
      }
      api._resetTabObject('assetPacks')
      api._resetSearchFilterObject(true, false)

      $timeout(() => {
        $scope.handleTabChange({ detail: { selected: selectedTab } })
      })

      SegmentService.track('workflow-external-view')
    })
  }

  function _checkShowOnlyAssetPacksTab () {
    return $rootScope.getCompanyFeatures().then(companyFeatures => {
      $scope.flags.showOnlyAssetPacksTab = companyFeatures.includes('GUEST_ASSET_PACK')
    })
  }

  function _initHeaderToolbar (locale) {
    const rightButtons = []

    if (!$scope.flags.showOnlyAssetPacksTab) {
      rightButtons.push({
        type: 'button',
        btnType: 'primary',
        label: $translate.instant('newRequest'),
        icon: 'plus',
        onClick: api._openRequestForm,
        disable: () => !hasBriefings
      })
    }

    $scope.headerToolbar = {
      search: {
        value: undefined,
        filters: GuestHeaderFiltersService.getHeaderFilters($scope.selectedTab, locale),
        onFilter: (newFilters, firstFilter, filtersCount) => {
          if (firstFilter) {
            return
          }

          if (filtersCount === 0) {
            filters = undefined
          } else {
            filters = newFilters
          }

          if (filtersCount === 0 && !search) {
            $scope.flags.isSearchingOrFiltering = false
            $scope.searchFilter = {
              items: [],
              count: 0
            }
            return
          }

          $scope.flags.isSearchingOrFiltering = true
          api._resetSearchFilterObject(false, true)
          api._search()
        },
        onSearch: (searchTerm) => {
          search = searchTerm

          if (!searchTerm && !filters) {
            $scope.flags.isSearchingOrFiltering = false
            $scope.searchFilter = {
              items: [],
              count: 0
            }
            search = undefined
            return
          }

          $scope.flags.isSearchingOrFiltering = true
          api._resetSearchFilterObject(false, true)
          api._search()
        }
      },
      rightButtons
    }
  }

  function _getApprovalsOverdueCount () {
    return ApprovalsService.getMyApprovalsOverdueCount().then(count => {
      $scope.approvalsOverdueCount = count
    })
  }

  function _getApprovals () {
    return ApprovalsService.getMyApprovals({ $top: $scope.approvals.$top, $skip: $scope.approvals.$skip, $sort: $scope.approvals.$sort, $order: $scope.approvals.$order }).then(result => {
      $scope.approvals.items.push(...result.rows)
      $scope.approvals.count = result.count
      $scope.approvals.loading = false
    })
  }

  function _getRequests () {
    return TasksService.getRequests({ $top: $scope.requests.$top, $skip: $scope.requests.$skip, $sort: $scope.requests.$sort, $order: $scope.requests.$order }).then(result => {
      $scope.requests.items.push(...result.rows)
      $scope.requests.count = result.count
      $scope.requests.loading = false
    })
  }

  function _getAssetPacks () {
    return $rootScope.getUser().then(user => {
      const params = {
        $top: $scope.assetPacks.$top,
        $skip: $scope.assetPacks.$skip,
        $sort: $scope.assetPacks.$sort,
        $order: $scope.assetPacks.$order
      }

      return GuestService.getAssetPacks(user.id, params).then(result => {
        $scope.assetPacks.items.push(...result.rows)
        $scope.assetPacks.count = result.count
        $scope.assetPacks.loading = false
      })
    })
  }

  function _clearSearchAndFilters () {
    $scope.$broadcast('advancedSearch.clearAllFilters')
    $scope.$broadcast('advancedSearch.clearSearch')
  }

  function _search () {
    if ($scope.selectedTab === 'assetPacks') {
      return api._searchAssetPacks()
    }

    return api._searchTasks()
  }

  function _searchAssetPacks () {
    return $rootScope.getUser().then(user => {
      const params = {
        $top: $scope.searchFilter.$top,
        $skip: $scope.searchFilter.$skip,
        $sort: $scope.searchFilter.$sort,
        $order: $scope.searchFilter.$order,
        search
      }

      return GuestService.getAssetPacks(user.id, params).then(result => {
        $scope.searchFilter.items.push(...result.rows)
        $scope.searchFilter.count = result.count
      }).finally(() => {
        $timeout(() => {
          $scope.searchFilter.loading = false
        })
      })
    })
  }

  function _searchTasks () {
    let taskTypes
    let approvalsOnly = false

    if ($scope.selectedTab === 'requests') {
      taskTypes = 'REQUEST'
      $scope.searchFilter.viewMode = 'REQUEST'
    } else {
      taskTypes = filters?.taskTypes || ['REQUEST', 'TASK']
      $scope.searchFilter.viewMode = 'TASK'
      approvalsOnly = true
    }

    const options = { ...(filters || {}), search, taskTypes, approvalsOnly, isArchived: false, $skip: $scope.searchFilter.$skip, $top: $scope.searchFilter.$top, $sort: $scope.searchFilter.$sort, $order: $scope.searchFilter.$order }

    return TasksService.getTasks(options).then(result => {
      $scope.searchFilter.items.push(...result.rows)
      $scope.searchFilter.count = result.count
    }).finally(() => {
      api._sendSearchEvent(filters, search)
      $timeout(() => {
        $scope.searchFilter.loading = false
      })
    })
  }

  function _openRequestForm () {
    api.getRequestFormDialogController().then(({ RequestFormDialogController }) => {
      ModalService.showModal({
        templateId: 'requestForm.html',
        templateUrl: '/workflow/dialogs/request-form/request-form-dialog.html?$$REVISION$$',
        controller: RequestFormDialogController,
        destroyable: true,
        observeChanges: true
      }).then(prop => {
        if ($scope.selectedTab === 'requests') {
          api._resetTabObject('requests', true)
          api._getRequests()
        }

        $rootScope.getUser().then(user => {
          api._getTabsCounts(user.id)
        })
      })
    })
  }

  function _resetSearchFilterObject (resetSorting = false, loading = false) {
    $scope.searchFilter.loading = loading
    $scope.searchFilter.loadingMore = false
    $scope.searchFilter.items = []
    $scope.searchFilter.count = 0
    $scope.searchFilter.$top = 10
    $scope.searchFilter.$skip = 0

    if ($scope.selectedTab === 'requests') {
      $scope.searchFilter.searchEmptyTitle = 'guest.searchRequestsEmptyTitle'
    } else if ($scope.selectedTab === 'approvals') {
      $scope.searchFilter.searchEmptyTitle = 'guest.searchApprovalsEmptyTitle'
    } else {
      $scope.searchFilter.searchEmptyTitle = 'guest.searchAssetPacksEmptyTitle'
    }

    $scope.searchFilter.searchEmptyMessage = $scope.selectedTab === 'assetPacks' ? 'sharedPacks.emptySearchMessage' : 'guest.searchResultsEmptyText'

    if (resetSorting && $scope.selectedTab !== 'assetPacks') {
      $scope.searchFilter.$sort = 'createdAt'
      $scope.searchFilter.$order = 'DESC'
    }
  }

  function _getTabsCounts (userId) {
    GuestService.getGuestSummary(userId).then((tabsCounts) => {
      $scope.tabsCounts = tabsCounts

      hasBriefings = tabsCounts.briefings > 0

      if (!$scope.$$phase) {
        $scope.$apply()
      }
    }).finally(() => {
      $scope.flags.loading = false
    })
  }

  function _resetTabObject (scopeObjectKey, loading = false) {
    $scope[scopeObjectKey] = {
      loading: loading,
      loadingMore: false,
      items: [],
      count: null,
      $top: 10,
      $skip: 0
    }

    if (scopeObjectKey === 'requests') {
      $scope[scopeObjectKey].$sort = 'createdAt'
      $scope[scopeObjectKey].$order = 'DESC'
    }

    if (scopeObjectKey === 'approvals') {
      $scope[scopeObjectKey].$sort = 'status'
      $scope[scopeObjectKey].$order = 'ASC'
    }
  }

  function _getSort (tab) {
    if (tab === 'approvals') {
      api._getApprovals()
    } else if (tab === 'requests') {
      api._getRequests()
    } else if (tab === 'assetPacks') {
      api._getAssetPacks()
    } else if (tab === 'searchFilter') {
      api._search()
    }
  }

  $translate.onReady(() => {
    $scope.requestsSortOptions = [
      {
        label: $translate.instant('recents'),
        value: 'createdAt',
        active: true
      },
      {
        label: $translate.instant('status'),
        value: 'status'
      },
      {
        label: $translate.instant('briefing'),
        value: 'briefing'
      }
    ]

    $scope.approvalsSortOptions = [
      {
        label: $translate.instant('approval'),
        value: 'status',
        active: true
      },
      {
        label: $translate.instant('priorityFilter'),
        value: 'tasks.priority'
      },
      {
        label: $translate.instant('status'),
        value: 'tasks.status'
      }
    ]

    $scope.searchResultsSortOptions = [
      {
        label: $translate.instant('recents'),
        value: 'createdAt',
        active: true
      },
      {
        label: $translate.instant('title'),
        value: 'title'
      },
      {
        label: $translate.instant('status'),
        value: 'status'
      }
    ]

    $rootScope.getUser().then(user => {
      $scope.guestTitle = `${$translate.instant('hello')}, ${user.name}`
      api._getTabsCounts(user.id)
    })
  })

  $scope.handleTabChange = async event => {
    api._resetSearchFilterObject()

    if (event.detail.selected && event.detail.selected !== $scope.selectedTab) {
      api._clearSearchAndFilters()

      $scope.selectedTab = event.detail.selected

      $rootScope.getUser().then(user => {
        api._initHeaderToolbar(user.locale)
      })
      return
    }

    switch ($scope.selectedTab) {
      case 'approvals':
        api._resetTabObject('approvals', true)
        api._getApprovalsOverdueCount()
        api._getApprovals()
        break
      case 'requests':
        api._resetTabObject('requests', true)
        api._getRequests()
        break
      case 'assetPacks':
        api._resetTabObject('assetPacks', true)
        api._getAssetPacks()
        break
    }
  }

  $scope.onChangeSortOrder = (tab) => {
    const sort = $scope[tab].$sort
    const order = $scope[tab].$order === 'ASC' ? 'DESC' : 'ASC'

    if (tab === 'searchFilter') {
      api._resetSearchFilterObject(false, true)
    } else {
      api._resetTabObject(tab, true)
    }

    $scope[tab].$sort = sort
    $scope[tab].$order = order

    api._getSort(tab)
  }

  $scope.onChangeSortSelect = (event, tab) => {
    event.preventDefault()
    event.stopPropagation()
    const value = event?.detail?.value

    if (value && tab) {
      if (tab === 'searchFilter') {
        api._resetSearchFilterObject(false, true)
      } else {
        api._resetTabObject(tab, true)
      }

      $scope[tab].$sort = value

      api._getSort(tab)
    }
  }

  $scope.loadMoreRequests = () => {
    try {
      $scope.requests.loadingMore = true
      $scope.requests.$skip = $scope.requests.$skip + $scope.requests.$top
      api._getRequests()
    } catch (error) {
      console.error({ error })
      ToastService.defaultErrorToast()
    } finally {
      $timeout(() => {
        $scope.requests.loadingMore = false
      }, 100)
    }
  }

  $scope.loadMoreApprovals = () => {
    try {
      $scope.approvals.loadingMore = true
      $scope.approvals.$skip = $scope.approvals.$skip + $scope.approvals.$top
      api._getApprovals()
    } catch (error) {
      console.error({ error })
      ToastService.defaultErrorToast()
    } finally {
      $timeout(() => {
        $scope.approvals.loadingMore = false
      }, 100)
    }
  }

  $scope.loadMoreAssetPacks = () => {
    try {
      $scope.assetPacks.loadingMore = true
      $scope.assetPacks.$skip = $scope.assetPacks.$skip + $scope.assetPacks.$top
      api._getAssetPacks()
    } catch (error) {
      console.error({ error })
      ToastService.defaultErrorToast()
    } finally {
      $timeout(() => {
        $scope.assetPacks.loadingMore = false
      }, 100)
    }
  }

  $scope.emptySearchResultBackButton = {
    icon: 'arrow-left',
    text: 'goBack',
    type: 'secondary',
    click: api._clearSearchAndFilters
  }

  $scope.loadMoreSearchResults = () => {
    $scope.searchFilter.loadingMore = true
    $scope.searchFilter.$skip = $scope.searchFilter.$skip + $scope.searchFilter.$top
    api._search().finally(() => {
      $timeout(() => { $scope.searchFilter.loadingMore = false })
    })
  }

  function _sendSearchEvent (filters, search) {
    const status = {
      INBOX: 'Entrada',
      WAITING_RESPONSE: 'Em aprovação',
      WAITING_USER_ADJUST: 'Ajustes',
      WAITING_ADM_ADJUST: 'Ajustes',
      PROGRESS: 'Em progresso',
      REVIEW: 'Em revisão',
      DONE: 'Finalizada',
      PENDING: 'Pendente',
      APPROVED: 'Aprovado',
      ADJUST: 'Ajustes',
      REJECTED: 'Reprovada'
    }

    const allPriorities = {
      LOW: 'Baixa',
      MEDIUM: 'Média',
      HIGH: 'Alta',
      URGENT: 'Urgente'
    }

    let selectedStatus; let selectedBriefings; let date; let taskStatus; let priorities; let approvalDeadline = ''

    if (filters) {
      const statusArray = filters.taskStatus?.map(item => {
        return status[item]
      })

      const prioritiesArray = filters.priorities?.map(item => {
        return allPriorities[item]
      })

      selectedStatus = statusArray ? statusArray.toString() : ''
      selectedBriefings = filters.form ? filters.form.toString() : ''
      date = filters.createdAt
      taskStatus = filters.approvalStatus ? status[filters.approvalStatus] : ''
      priorities = prioritiesArray ? prioritiesArray.toString() : ''
      approvalDeadline = filters.approvalDeadline
    }

    SegmentService.track('workflow-external-search', {
      search_text: search,
      filter_status: selectedStatus,
      filter_briefing: selectedBriefings,
      filter_create_date: date,
      filter_task_status: taskStatus,
      filter_priorities: priorities,
      filter_approval_deadline: approvalDeadline
    })
  }

  function _reloadApprovalsTab () {
    $rootScope.getUser().then(user => {
      api._getTabsCounts(user.id)
    })

    if ($scope.selectedTab !== 'approvals') {
      return
    }

    api._resetTabObject('approvals', true)
    api._getApprovalsOverdueCount()
    api._getApprovals()
  }

  // Event from <approval-list-item> directive.
  const deregisterReloadApprovalsTab = $scope.$on('workflow.home.reloadApprovalsTab', api._reloadApprovalsTab)

  $scope.$on('$destroy', () => {
    deregisterReloadApprovalsTab()
  })
}

export { HomeController }
